var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBookingCalendarDay = function SvgBookingCalendarDay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#867659",
    d: "M8.402 3v-.6h-1.2v2.4h-3.6v16.8h16.8V4.8h-3.6V2.4h-1.2v2.4h-7.2zm-3.6 6.6h14.4v10.8h-14.4zm0-3.6h14.4v2.4h-14.4zm2.4 6h3.6v3.6h-3.6zm-1.2-1.2v6h6v-6h-6"
  })));
};
export default SvgBookingCalendarDay;